import React, { ReactNode } from 'react';
import { default as AntdCheckbox, CheckboxProps as AntdCheckboxProps } from 'antd/es/checkbox';
import cx from 'clsx';

import style from './index.module.scss';

export type CheckboxProps = {
  children: ReactNode;
  className?: string;
  type?: 'primary' | 'form';
  isCircle?: boolean;
} & AntdCheckboxProps;

export const Checkbox = ({ className, children, type, isCircle, ...props }: CheckboxProps) => {
  return (
    <label className={style.checkboxWrapper}>
      <AntdCheckbox
        className={cx(style.checkbox, type === 'form' && 'is-form', isCircle && style.circle)}
        {...props}
      />
      {children}
    </label>
  );
};
